import { render, staticRenderFns } from "./AudioTool.vue?vue&type=template&id=1c027fe3&scoped=true&"
import script from "./AudioTool.vue?vue&type=script&lang=js&"
export * from "./AudioTool.vue?vue&type=script&lang=js&"
import style0 from "./AudioTool.vue?vue&type=style&index=0&id=1c027fe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c027fe3",
  null
  
)

export default component.exports